export default __webpack_public_path__ + "static/how-we-build-companies-horizontal-sm-80b84656cdfa3a7b3489834a5a9ac265.svg";